import { createSlice } from '@reduxjs/toolkit';

const getPrintHistorySlice = createSlice({
  name: 'getPrintHistory',
  initialState: {
    loading: false,
    printHistory: null,
    error: null,
    success: false
  },
  reducers: {
    getPrintHistoryRequest(state) {
      state.loading = true;
      state.error = null;
    },
    getPrintHistorySuccess(state, action) {
      state.loading = false;
      state.success = true
      state.printHistory = action.payload;
    },
    getPrintHistoryFailure(state, action) {
      state.loading = false;
      state.success = false
      state.error = action.payload;
    },
    getPrintHistoryReset(state) {
      state.loading = false;
      state.printHistory = null;
      state.success = false
      state.error = null;
    }
  },
});

export const { 
  getPrintHistoryRequest, 
  getPrintHistorySuccess, 
  getPrintHistoryFailure,
  getPrintHistoryReset 
} = getPrintHistorySlice.actions;

export default getPrintHistorySlice.reducer;

